/**
 * Меню редких действий доски (участники, обмен, COA, offline…).
 */
import { useState, type ReactNode } from "react";
import { MoreHorizontal } from "lucide-react";
import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

type Props = {
  disabled?: boolean;
  children: ReactNode;
};

export function TacticalBoardMenu({ disabled, children }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <div className="flex items-center gap-1">
        <DialogTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="h-7 px-2"
            disabled={disabled}
            title="Меню доски"
            aria-label="Меню доски"
          >
            <MoreHorizontal className="h-4 w-4" />
            <span className="ml-1 text-xs">Доска</span>
          </Button>
        </DialogTrigger>
        <SectionHelpTooltip label="Справка: меню доски">
          <p>Редкие операции: обмен, сравнение COA, участники, offline-тайлы, удаление.</p>
          <ul className="list-disc space-y-1 pl-4">
            <li>Рисование — инструменты сверху карты.</li>
            <li>Слои и объекты — в левой колонке.</li>
            <li>Стиль и карточка — справа в инспекторе.</li>
          </ul>
        </SectionHelpTooltip>
      </div>
      <DialogContent className="z-[250] max-h-[85vh] max-w-md overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-base">Действия доски</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pb-2">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
